<template>
		<a class="astana-club"  href="http://astanaclub.kz" target="_blank">
			<div class="container">
				<img src="../assets/img/astana-club.png" alt="Astana Club" height="60">
				<div class="text">
					{{tr.astana_club_banner_text}}
				</div>
			</div>
		</a>
</template>

<script>
export default {
  name: 'astana-club',
  computed:{
    lang(){return this.$store.state.lang;},
    tr(){return this.$store.getters.translates;}
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
.astana-club{
	background: #0f5da0;
	padding:30px 0;
	color:white;
	overflow: hidden;
	display: block;
	text-decoration: none;
	font-size:24px;
	font-weight: bold;
	transition: 0.3s all ease;
}
.astana-club:hover{
	cursor: pointer;
	/*background: #3b6583;*/
}

.astana-club img{
	float:left;
	vertical-align: middle;
}
.astana-club .text{
	vertical-align: middle;
	padding-left: 160px;
	padding-top:18px;
	text-align: center;
}

@media(max-width:992px){
	.astana-club .text{
		padding-left: none;
		text-align: center;
		padding-left: 0;
		padding-bottom: 12px;

	}
	.astana-club img{
		float:none;
		display: block;
		margin:auto;
	}
}
</style>